import React, {Component} from 'react';
import styled from "styled-components";
import Papa from 'papaparse';
import FileSaver from 'filesaver.js';

import Screen from '../../components/Screen';
import Content from '../../components/Content';
import FileInput from '../../components/FileUpload';
import Form from '../../components/Form';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Card from '../../components/Card';
import Loading from '../../components/Loading';

import * as ThermFisherTransformSentinal from './ThermoFisherTransformSentinal';

const transforms = [
  ThermFisherTransformSentinal
];

class TransformsScreen extends Component {
  state = {
    type: 0,
    file: null,
    working: false
  }

  parseFile() {
    this.setState({working: true});
    transforms[this.state.type].transform(this.state.file, (headers, rows) => {
      FileSaver.saveAs(new Blob([Papa.unparse({fields: headers, data: rows})]), `${this.state.file.name.substring(0, this.state.file.name.length - 4)}_converted.csv`);
      
      this.setState({working: false});
    });
  }

  render() {
    return (
      <Screen title="Transforms" activeLink="Transforms" showTitle={true}>
        <Content>
          <CardContainer>
            <Card.Content>
              <Form onSubmit={() => this.parseFile()}>
                <Form.Group>
                  <Input
                    id="type"
                    type="select"
                    label="Transform type"
                    value={this.state.type}
                    onChange={e => this.setState({type: e.target.value})}>
                      {transforms.map((t,i) => (
                        <option id={i} value={i}>{t.name()}</option>
                      ))}
                  </Input>
                </Form.Group>
                <Form.Group>
                  <FileInput id="csv" label="Upload File" allowedTypes={["csv"]} onFilesAdd={(files) => this.setState({file: files.length > 0 ? files[0].file : null})} maxMB={2} />
                </Form.Group>
                <ButtonGroup>
                  {
                    this.state.working ? <Loading /> : <Button type="submit" disabled={this.state.working || !this.state.file}>Submit</Button>
                  }
                </ButtonGroup>
              </Form>
            </Card.Content>
          </CardContainer>
          <CardContainer>
            <Card.Title>
              How to use the transformed file
            </Card.Title>
            <Card.Content>
                {transforms[this.state.type].importDetails()}
            </Card.Content>
          </CardContainer>
        </Content>
      </Screen>
    );
  }
}

const ButtonGroup = styled(Form.Group)`
  Button {
    margin-right: 10px;
  }
`

const CardContainer = styled(Card)`
  margin-bottom: 2rem;
`;

export default TransformsScreen;